module.exports = __webpack_public_path__ + "static/img/stoerer_events.8f67b20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/stoerer_events.png
// module id = HsaN
// module chunks = 2